import { Link } from 'react-router-dom'
import { Nav } from '../components/layout/Nav'
import { Footer } from '../components/layout/Footer'
import { Button } from '../components/ui/Button'

export default function NotFound() {
  return (
    <>
      <Nav />
      <main className="min-h-screen pt-24 pb-16 px-6 flex flex-col items-center justify-center">
        <h1 className="font-display font-black text-6xl uppercase text-white mb-4">404</h1>
        <p className="font-body text-cream-dim text-lg mb-8">Page not found.</p>
        <Button to="/" variant="primary">
          Go to Home
        </Button>
      </main>
      <Footer />
    </>
  )
}
